import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Login from './components/Login';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import reportWebVitals from './reportWebVitals';

function Root() {
  const { currentUser } = useAuth();

  return currentUser ? <App /> : <Login />;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <Root />
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();
